module.exports = __webpack_public_path__ + "img/virusColectivo.cb274156.jpg";